module.exports = __webpack_public_path__ + "static/index/img/baikal-403.88510644.jpg";